import React from "react";

const Appointments = () => {
  return <div className="p-10 bg-gray-100">Appointments</div>;
};

export default Appointments;
